import React from "react";
import { RouteComponentProps } from "@reach/router"
import AppPage from "../../components/AppFrame/AppPage";

import { actions } from '../../services/stats';
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../store";
import {
  Container,
  Tab,
  Tabs,
} from "@material-ui/core";
import { Box } from "@material-ui/system";
import { NumberParam, useQueryParam } from "use-query-params";
import TabPanel from "../../components/TabPanel";
import TabUsers from "./TabUsers";
import TabChats from "./TabChats";
import TabMatches from "./TabMatches";
import TabWallet from "./TabWallet";


const DashboardPage: React.FC<RouteComponentProps> = () => {

  const stats = useSelector((state: RootState) => state.stats);
  const [ tabIndex, setTabIndex ] = useQueryParam('tab', NumberParam);

  const handleChange = (event: any, newValue: any) => {
    setTabIndex(newValue);
  };

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(actions.init());

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const tab = tabIndex ?? 0;

  return (
    <AppPage title="Dashboard" loading={stats.loading}>
      <Container maxWidth="md">
        <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 5 }}>
          <Tabs value={tab} onChange={handleChange} variant="scrollable">
            <Tab label="Users / Photos" />
            <Tab label="Chats / Messages" />
            <Tab label="Matches / Swipes" />
            <Tab label="Wallet / IAP" />
          </Tabs>
        </Box>

        <TabPanel value={tab} index={0}>
          <TabUsers />
        </TabPanel>

        <TabPanel value={tab} index={1}>
          <TabChats />
        </TabPanel>

        <TabPanel value={tab} index={2}>
          <TabMatches />
        </TabPanel>

        <TabPanel value={tab} index={3}>
          <TabWallet />
        </TabPanel>

      </Container>

    </AppPage>
  );
};

export default DashboardPage;